// @flow
export const GET_LEADS = {
	START: 'GET_LEADS.START',
	SUCCESS: 'GET_LEADS.SUCCESS',
	FAIL: 'GET_LEADS.FAIL',
};
